import Quill, { Delta } from 'quill/core';
import React from 'react';
import { MenuItem } from '../../components/Menu';
import embedIcon from '../../icons/non-prefilled/16x16/embed.svg';
import getExtname from '../../utils/url/getExtname';
import type Attachment from '../formats/Attachment';
import type AttachmentMention from '../formats/AttachmentMention';
import FileBlot from '../formats/FileBlot';

const createNewLine = (quill: Quill, index: number) => {
  const [line, offset] = quill.getLine(index);
  if (line) {
    line.split(offset);
    quill.update();

    // + `1` for the "\n" created by #split()
    quill.setSelection(index + 1, Quill.sources.SILENT);
    return index + 1;
  }
  return index;
};

interface DetachIntoFileEmbedMenuItemProps {
  quill: Quill;
  blot: Attachment | AttachmentMention;
  source: string;
  text?: string;
}

const DetachIntoFileEmbedMenuItem = ({
  quill,
  blot,
  source,
  text = 'Detach into embed',
}: DetachIntoFileEmbedMenuItemProps) => {
  const file = blot.getAttachmentFiles().find((f) => f.source === source);

  if (!file || !FileBlot.supportedExtensions.has(getExtname(file.source))) {
    return null;
  }

  return (
    <MenuItem
      icon={embedIcon}
      onClick={() => {
        const index = quill.getIndex(blot);
        const newIndex = createNewLine(quill, index);
        const delta = new Delta().retain(newIndex).insert({ file });

        quill.updateContents(delta, Quill.sources.USER);
        blot.handleDeleteAttachment(source);
      }}
      testId="detachIntoFileEmbed"
    >
      {text}
    </MenuItem>
  );
};

export default DetachIntoFileEmbedMenuItem;
